/* Veltron — fichário de configuração do banco traseiro por veículo.
   Chaves: marca (minúscula) -> modelo (minúscula, casa por "contém") -> gerações [{from, to, questions}].
   Veículo sem ficha usa as perguntas genéricas do widget.
   Fonte inicial: mapeamento de fitment por geração (validar com a equipe). */
window.VELTRON_REAR_CONFIG = {
  "ford": {
    "f-150": [
      { "from": 2021, "to": 2026, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "60/40 + Cupholder", "icon": "t6040cup" },
          { "label": "60/40 + No Cupholder", "icon": "t6040" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" } ] }
      ] },
      { "from": 2015, "to": 2020, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "60/40 + Cupholder", "icon": "t6040cup" },
          { "label": "60/40 + No Cupholder", "icon": "t6040" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" } ] }
      ] },
      { "from": 2011, "to": 2014, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "60/40 + Cupholder", "icon": "t6040cup" },
          { "label": "60/40 + No Cupholder", "icon": "t6040" },
          { "label": "One Piece + No Cupholder", "icon": "tsolid" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" } ] }
      ] }
    ]
  },
  "chevrolet": {
    "silverado": [
      { "from": 2019, "to": 2026, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "No Compartments", "icon": "nocomp" },
          { "label": "3 Compartments", "icon": "threecomp" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" } ] }
      ] },
      { "from": 2014, "to": 2018, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "Cupholder", "icon": "t6040cup" },
          { "label": "No Cupholder", "icon": "t6040" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" },
          { "label": "One Piece", "icon": "bsolid" } ] }
      ] }
    ]
  },
  "gmc": {
    "sierra": [
      { "from": 2019, "to": 2026, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "No Compartments", "icon": "nocomp" },
          { "label": "3 Compartments", "icon": "threecomp" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" } ] }
      ] },
      { "from": 2014, "to": 2018, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "Cupholder", "icon": "t6040cup" },
          { "label": "No Cupholder", "icon": "t6040" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" },
          { "label": "One Piece", "icon": "bsolid" } ] }
      ] }
    ]
  },
  "ram": {
    "1500": [
      { "from": 2019, "to": 2026, "questions": [
        { "prop": "Center Armrest/Cupholder", "text": "Does your rear seat have a center cupholder/armrest?", "options": [
          { "label": "Yes" }, { "label": "No" } ] },
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "60/40 + Adjustable Middle Headrest", "icon": "t6040" },
          { "label": "60/40 + Molded Middle Headrest", "icon": "t6040" },
          { "label": "40/20/40 + Molded Middle Headrest", "icon": "t402040" },
          { "label": "One Piece + Molded Headrest", "icon": "tsolid" },
          { "label": "One Piece + Adjustable Headrest", "icon": "tsolid" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40 + Curved", "icon": "b6040" },
          { "label": "60/40 + Flat", "icon": "b6040" },
          { "label": "One Piece + Curved", "icon": "bsolid" },
          { "label": "One Piece + Flat", "icon": "bsolid" } ] }
      ] },
      { "from": 2011, "to": 2018, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "60/40 + Cupholder", "icon": "t6040cup" },
          { "label": "60/40 + No Cupholder", "icon": "t6040" },
          { "label": "One Piece", "icon": "tsolid" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40 + Curved", "icon": "b6040" },
          { "label": "One Piece + Flat", "icon": "bsolid" } ] }
      ] }
    ]
  },
  "toyota": {
    "tacoma": [
      { "from": 2016, "to": 2026, "questions": [
        { "prop": "Rear Seat Top Style", "text": "What rear seat top style do you have?", "options": [
          { "label": "60/40", "icon": "t6040" } ] },
        { "prop": "Rear Bench Style", "text": "What rear seat bench style do you have?", "options": [
          { "label": "60/40", "icon": "b6040" } ] }
      ] }
    ]
  }
};
